import { RouteConfig } from 'vue-router';


const Account = () => import(/* webpackChunkName:"Account" */ '../account/account.vue');
const System = () => import(/* webpackChunkName:"System" */ '../system/system.vue');
const App = () => import(/* webpackChunkName:"App" */ '../app/app.vue');

import AccountRouters from "../account/account.router";
import SystemRouters from "../system/system.router";
import AppRouters from "../app/app.router";

const routers: RouteConfig[] = [
    {
        path: 'account',
        component: Account,
        children: AccountRouters
    },
    {
        path: "system",
        component: System,
        children: SystemRouters
    },
    {
        path: "app",
        component: App,
        children: AppRouters
    },
    {
        path: '',
        redirect: 'system'
    },
];

export default routers;
